import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  inject,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ScrollService } from '@services/scroll.service';

/**
 * Simple page wrapper component that provides consistent background styling
 * and routing shell. Container sizing is handled by global .ap-page-container
 * class applied manually to each page's root element.
 */
@Component({
  selector: 'app-page-wrapper',
  templateUrl: './page-wrapper.component.html',
  imports: [RouterOutlet],
  styleUrls: ['./page-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageWrapperComponent implements OnInit {
  @ViewChild('pageWrapper', { static: true })
  mainContainer!: ElementRef<HTMLElement>;

  private scrollService = inject(ScrollService);

  ngOnInit(): void {
    // Register the sole scroll container and let the ScrollService
    // handle scroll-to-top on route changes (fragment-aware).
    this.scrollService.registerScrollContainer(
      this.mainContainer.nativeElement,
    );
    this.scrollService.initRouteScrollReset();
  }
}
